﻿import * as pieChart from "@arcgis/core/smartMapping/renderers/pieChart";
import {
    buildDotNetRenderer, 
    buildDotNetAggregateField,
    buildDotNetVisualVariableResult,
    buildDotNetPieChartScheme
} from "./dotNetBuilder";
import {arcGisObjectRefs, copyValuesIfExists, hasValue} from "./arcGisJsInterop";


export default class PieChartCreatorWrapper {
    private dotNetRef: any;
    constructor(dotNetRef) {
        this.dotNetRef = dotNetRef;
    }
    
    async createRenderer(options: any): Promise<any> {
        let jsResult = await pieChart.createRenderer({
            layer: arcGisObjectRefs[options.layer.id] as any,
            view: arcGisObjectRefs[options.viewId] as any,
            attributes: options.attributes,
            shape: options.shape,
            includeSizeVariable: options.includeSizeVariable,
            outlineOptimizationEnabled: options.outlineOptimizationEnabled,
            legendOptions: options.legendOptions,
            pieChartScheme: options.pieChartScheme,
            forBinning: options.forBinning
        });
        let dnResult: any = {};
        dnResult.renderer = buildDotNetRenderer(jsResult.renderer);
        dnResult.size = buildDotNetVisualVariableResult(jsResult.size);
        dnResult.pieChartScheme = buildDotNetPieChartScheme(jsResult.pieChartScheme);
        copyValuesIfExists(jsResult, dnResult, 'basemapId', 'basemapTheme', 'statistics');
    }
    
    async createRendererForClustering(options: any): Promise<any> {
        let jsRenderer = await pieChart.createRendererForClustering({
            layer: arcGisObjectRefs[options.layer.id] as any,
            shape: options.shape,
            defaultSymbolEnabled: options.defaultSymbolEnabled,
            legendOptions: options.legendOptions
        });
        let dnResult: any = {
            renderer: buildDotNetRenderer(jsRenderer.renderer)
        };
        if (hasValue(jsRenderer.fields)) {
            dnResult.fields = jsRenderer.fields.map(buildDotNetAggregateField);
        }
        
        return dnResult;
    }
}